<template>
	<div class="rent">
		<div class="page-container">
			<PageTitle ch="場地租借" en="Rental"></PageTitle>
			<a class="download" target="_blank" href="https://goo.gl/J7yT8D">下載利澤國際偶戲藝術村場地租借辦法</a>
			<a class="download" target="_blank" href="https://drive.google.com/file/d/15AkccgVFQHH3w_piZapO143M4kHVWbwk/view">Download Lize International Puppet Art Colony Rental Policy</a>
			<img class="desktop" src="@/assets/rent/rent-desktop.png" alt="" srcset="">
			<img class="mobile" src="@/assets/rent/rent-mobile.png" alt="" srcset="">
			<SpaceIntro></SpaceIntro>
			<iframe src="https://goo.gl/H9Vznn" frameborder="0"></iframe>
		</div>
	</div>
</template>

<script>
import PageTitle from '@/components/page_title'
import SpaceIntro from '@/components/space_intro'

export default {
  metaInfo: {
    title: '利澤國際偶戲藝術村'
  },
  name: 'rent',
  data() {
    return {

    }
  },
  components: {
    PageTitle,
    SpaceIntro
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'
  .rent
    .page-container
      +flexLayout('center', 'col')
      .download
        color: white
        font-size: $font-size-3
        padding: 25px 80px
        border-radius: 100px
        background-color: #01b6e2
        margin: 0 5px 20px 5px
        cursor: pointer
      .desktop
        display: block
        width: 100%
        margin: 30px 0 80px 0
        max-width: 1000px
      .mobile
        display: none
        width: 100%
        max-width: 220px
        margin: 30px 0 80px 0
      iframe
        +size(100%, 1000px)
      @media all and (max-width: 800px)
        .desktop
          display: none
        .mobile
          display: block
        .download
          color: white
          font-size: 16px
          padding: 10px 29px
          margin: 0 5px 10px 5px
          line-height: 1.3
          max-width: 340px
</style>



// WEBPACK FOOTER //
// src/pages/rent/rent.vue